/**
 * PDP gallery: swipe + arrows + lightbox zoom.
 * Lightbox: full-image fit, pinch/double-tap zoom + pan, swipe between slides at 1x.
 */
(function () {
  var MAX_SCALE = 4;
  var MIN_SCALE = 1;
  var DOUBLE_TAP_MS = 280;

  function chevronSvg(dir) {
    // dir: -1 prev (left), 1 next (right) — square-cap chevron, not a browser glyph
    var d =
      dir < 0
        ? "M14 5L8 12l6 7"
        : "M10 5l6 7-6 7";
    return (
      '<svg class="zt-gallery-arrow__icon" width="12" height="12" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="' +
      d +
      '" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="square" stroke-linejoin="miter"/>' +
      "</svg>"
    );
  }

  function migrateHostChild(host, className) {
    var el = host.querySelector("." + className);
    if (el) return el;
    var wrapper = host.closest(".product__media-wrapper");
    if (!wrapper || wrapper === host) return null;
    el = wrapper.querySelector("." + className);
    if (el) host.appendChild(el);
    return el;
  }

  function ensureNav(host, total) {
    var nav = migrateHostChild(host, "zt-gallery-nav");
    if (!nav) {
      nav = document.createElement("div");
      nav.className = "zt-gallery-nav";
      nav.setAttribute("data-zt-gallery-nav", "1");
      nav.innerHTML =
        '<button type="button" class="zt-gallery-arrow zt-gallery-arrow--prev" aria-label="Previous image">' +
        chevronSvg(-1) +
        "</button>" +
        '<button type="button" class="zt-gallery-arrow zt-gallery-arrow--next" aria-label="Next image">' +
        chevronSvg(1) +
        "</button>";
      host.appendChild(nav);
    } else {
      // Refresh icons if an older thin-chevron build is still in the DOM.
      var prevBtn = nav.querySelector(".zt-gallery-arrow--prev");
      var nextBtn = nav.querySelector(".zt-gallery-arrow--next");
      if (prevBtn && !prevBtn.querySelector(".zt-gallery-arrow__icon")) {
        prevBtn.innerHTML = chevronSvg(-1);
      }
      if (nextBtn && !nextBtn.querySelector(".zt-gallery-arrow__icon")) {
        nextBtn.innerHTML = chevronSvg(1);
      }
    }
    nav.hidden = total < 2;
    return {
      nav: nav,
      prev: nav.querySelector(".zt-gallery-arrow--prev"),
      next: nav.querySelector(".zt-gallery-arrow--next"),
    };
  }

  function activeIndexFromScroll(scroller, items) {
    if (!items.length) return 0;
    var left = scroller.scrollLeft;
    var best = 0;
    var bestDist = Infinity;
    for (var i = 0; i < items.length; i++) {
      var dist = Math.abs(items[i].offsetLeft - left);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    }
    return best;
  }

  function bindGallery(gallery) {
    if (gallery.dataset.ztGalleryBound === "1") return;
    gallery.dataset.ztGalleryBound = "1";

    var list = gallery.querySelector(".product__media-list");
    if (!list) return;

    // Host nav on media-gallery so vertical center matches the image frame
    // (not the taller sticky .product__media-wrapper column on desktop).
    var host = gallery;
    var items = list.querySelectorAll(".product__media-item");
    var total = items.length;
    // Remove legacy "1 / N" counters if still in the DOM.
    host.querySelectorAll(".zt-gallery-count").forEach(function (el) {
      el.remove();
    });
    var wrapper = host.closest(".product__media-wrapper");
    if (wrapper) {
      wrapper.querySelectorAll(".zt-gallery-count").forEach(function (el) {
        el.remove();
      });
    }
    var arrows = ensureNav(host, total);
    gallery._ztGoTo = goTo;
    gallery._ztList = list;

    function getItems() {
      return list.querySelectorAll(".product__media-item");
    }

    bindGalleryPinch(gallery, list, getItems);

    if (total < 2) return;

    var navRevealTimer = null;
    function flashNav() {
      gallery.classList.add("is-zt-nav-visible");
      if (navRevealTimer) window.clearTimeout(navRevealTimer);
      navRevealTimer = window.setTimeout(function () {
        gallery.classList.remove("is-zt-nav-visible");
        navRevealTimer = null;
      }, 1800);
    }

    gallery.addEventListener(
      "pointerdown",
      function (e) {
        if (e.pointerType === "mouse") return;
        flashNav();
      },
      { passive: true }
    );

    function slideLeft(index) {
      var target = items[index];
      if (!target) return 0;
      var left = target.offsetLeft;
      // Prefer measured offset; fall back to clientWidth steps if layout reports 0.
      if (index > 0 && left < 1) left = Math.round(list.clientWidth * index);
      return left;
    }

    // Wrap so next from last → first and prev from first → last.
    function wrapIndex(index) {
      if (total < 1) return 0;
      return ((index % total) + total) % total;
    }

    function goTo(index) {
      var next = wrapIndex(index);
      var left = slideLeft(next);
      if (typeof list.scrollTo === "function") {
        list.scrollTo({ left: left, behavior: "smooth" });
      } else {
        list.scrollLeft = left;
      }
      window.requestAnimationFrame(paint);
    }

    function paint() {
      // Wrap mode: arrows stay enabled at both ends.
      if (arrows.prev) {
        arrows.prev.disabled = false;
        arrows.prev.setAttribute("aria-disabled", "false");
      }
      if (arrows.next) {
        arrows.next.disabled = false;
        arrows.next.setAttribute("aria-disabled", "false");
      }
    }

    function onArrowActivate(e, delta) {
      // Capture-phase: beat Dawn product__media-toggle / lightbox openers.
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();
      goTo(activeIndexFromScroll(list, items) + delta);
    }

    function isTypingTarget(el) {
      if (!el || el.nodeType !== 1) return false;
      var tag = el.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return true;
      if (el.isContentEditable) return true;
      return false;
    }

    // Keyboard Left/Right when gallery is hovered, focused, or in view.
    if (!gallery.hasAttribute("tabindex")) gallery.setAttribute("tabindex", "0");
    var galleryHovered = false;
    var galleryInView = true;
    gallery.addEventListener("mouseenter", function () {
      galleryHovered = true;
    });
    gallery.addEventListener("mouseleave", function () {
      galleryHovered = false;
    });
    if (typeof IntersectionObserver === "function") {
      var io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].target === gallery) {
              galleryInView = entries[i].isIntersecting;
            }
          }
        },
        { threshold: 0.25 }
      );
      io.observe(gallery);
    }
    document.addEventListener("keydown", function (e) {
      if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
      if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey) return;
      if (isTypingTarget(e.target)) return;
      var focused =
        document.activeElement === gallery || gallery.contains(document.activeElement);
      if (!galleryHovered && !focused && !galleryInView) return;
      e.preventDefault();
      goTo(activeIndexFromScroll(list, items) + (e.key === "ArrowRight" ? 1 : -1));
      flashNav();
    });

    function bindArrow(btn, delta) {
      if (!btn || btn.dataset.ztArrowBound === "1") return;
      btn.dataset.ztArrowBound = "1";
      btn.setAttribute("type", "button");
      // pointerdown (capture) stops the lightbox toggle under tiny miss-hits near the control.
      btn.addEventListener(
        "pointerdown",
        function (e) {
          if (e.button != null && e.button !== 0) return;
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();
        },
        true
      );
      btn.addEventListener(
        "click",
        function (e) {
          onArrowActivate(e, delta);
        },
        true
      );
    }

    bindArrow(arrows.prev, -1);
    bindArrow(arrows.next, 1);

    paint();
    list.addEventListener("scroll", paint, { passive: true });
    window.addEventListener("resize", paint, { passive: true });
    bindWrapGestures(
      list,
      function () {
        return items;
      },
      function (index) {
        if (gallery.classList.contains("is-zt-zoomed")) return;
        goTo(index);
      }
    );
  }

  function bindGalleryPinch(gallery, list, getItems) {
    if (!list || list.dataset.ztPinchBound === "1") return;
    list.dataset.ztPinchBound = "1";

    var scale = 1;
    var tx = 0;
    var ty = 0;
    var img = null;
    var pinchStartDist = 0;
    var pinchStartScale = 1;
    var panStartX = 0;
    var panStartY = 0;
    var panOriginTx = 0;
    var panOriginTy = 0;
    var gesturing = false;
    var blockClickUntil = 0;

    function currentImg() {
      var kids = getItems() || [];
      if (!kids.length) return null;
      var slide = kids[activeIndexFromScroll(list, kids)] || kids[0];
      return slide ? slide.querySelector("img") : null;
    }

    function frameRect() {
      var frame = (img && (img.closest(".media") || img.parentElement)) || list;
      return frame.getBoundingClientRect();
    }

    function applyTransform() {
      if (!img) return;
      var zoomed = scale > 1.01;
      gallery.classList.toggle("is-zt-zoomed", zoomed);
      if (!zoomed) {
        img.style.transform = "";
        tx = 0;
        ty = 0;
        return;
      }
      img.style.transform =
        "translate3d(" + tx + "px," + ty + "px,0) scale(" + scale + ")";
    }

    function resetZoom() {
      scale = 1;
      tx = 0;
      ty = 0;
      if (img) img.style.transform = "";
      gallery.classList.remove("is-zt-zoomed");
    }

    function setActiveFromScroll() {
      var next = currentImg();
      if (next !== img) {
        if (img) img.style.transform = "";
        img = next;
        scale = 1;
        tx = 0;
        ty = 0;
        gallery.classList.remove("is-zt-zoomed");
        if (img) {
          img.draggable = false;
          img.setAttribute("sizes", "200vw");
        }
      }
    }

    function clampPan() {
      if (!img || scale <= 1) {
        tx = 0;
        ty = 0;
        return;
      }
      var r = frameRect();
      var maxX = Math.max(0, (img.offsetWidth * scale - r.width) / 2 + 8);
      var maxY = Math.max(0, (img.offsetHeight * scale - r.height) / 2 + 8);
      tx = clamp(tx, -maxX, maxX);
      ty = clamp(ty, -maxY, maxY);
    }

    list.addEventListener(
      "scroll",
      function () {
        if (scale > 1.01) return;
        setActiveFromScroll();
      },
      { passive: true }
    );

    gallery.addEventListener(
      "touchstart",
      function (e) {
        if (!list.contains(e.target)) return;
        setActiveFromScroll();
        if (!img) return;

        if (e.touches.length === 2) {
          gesturing = true;
          blockClickUntil = Date.now() + 500;
          pinchStartDist = distance(e.touches[0], e.touches[1]);
          pinchStartScale = scale;
          e.preventDefault();
          return;
        }

        if (e.touches.length === 1 && scale > 1.01) {
          gesturing = true;
          panStartX = e.touches[0].clientX;
          panStartY = e.touches[0].clientY;
          panOriginTx = tx;
          panOriginTy = ty;
        }
      },
      { passive: false, capture: true }
    );

    gallery.addEventListener(
      "touchmove",
      function (e) {
        if (!list.contains(e.target) && e.touches.length < 2) return;
        if (!img) return;

        if (e.touches.length === 2 && pinchStartDist) {
          var dist = distance(e.touches[0], e.touches[1]);
          var mid = midpoint(e.touches[0], e.touches[1]);
          var next = (pinchStartScale * dist) / pinchStartDist;
          var prevScale = scale;
          scale = clamp(next, MIN_SCALE, MAX_SCALE);
          if (prevScale !== scale) {
            var r = frameRect();
            var midX = r.left + r.width / 2;
            var midY = r.top + r.height / 2;
            var ratio = scale / (prevScale || 1);
            tx = mid.x - midX - (mid.x - midX - tx) * ratio;
            ty = mid.y - midY - (mid.y - midY - ty) * ratio;
          }
          if (scale <= 1.01) {
            resetZoom();
          } else {
            clampPan();
            applyTransform();
          }
          e.preventDefault();
          return;
        }

        if (e.touches.length === 1 && scale > 1.01 && gesturing) {
          tx = panOriginTx + (e.touches[0].clientX - panStartX);
          ty = panOriginTy + (e.touches[0].clientY - panStartY);
          clampPan();
          applyTransform();
          e.preventDefault();
        }
      },
      { passive: false, capture: true }
    );

    gallery.addEventListener(
      "touchend",
      function (e) {
        if (e.touches.length < 2) pinchStartDist = 0;
        if (e.touches.length === 0) {
          gesturing = false;
          if (scale <= 1.01) resetZoom();
        }
      },
      { passive: true, capture: true }
    );

    gallery.addEventListener(
      "click",
      function (e) {
        if (!list.contains(e.target)) return;
        if (scale > 1.01 || Date.now() < blockClickUntil) {
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === "function") {
            e.stopImmediatePropagation();
          }
        }
      },
      true
    );
  }

  // Native overflow stops at the last slide. Catch the extra swipe/wheel and wrap.
  function bindWrapGestures(scroller, getItems, goToFn) {
    if (!scroller || scroller.dataset.ztWrapBound === "1") return;
    scroller.dataset.ztWrapBound = "1";
    var lockUntil = 0;
    var startX = 0;
    var startY = 0;
    var startLeft = 0;

    function items() {
      return getItems() || [];
    }

    function zoomLocked() {
      var g = scroller.closest("media-gallery");
      if (g && g.classList.contains("is-zt-zoomed")) return true;
      var m = scroller.closest("product-modal");
      if (m && m.classList.contains("is-zoomed")) return true;
      if (scroller.classList.contains("is-zoomed")) return true;
      return false;
    }

    function atEnds() {
      var kids = items();
      if (kids.length < 2) return { start: false, end: false, index: 0 };
      var index = activeIndexFromScroll(scroller, kids);
      var maxLeft = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      return {
        start: index === 0 && scroller.scrollLeft <= 8,
        end: index === kids.length - 1 && scroller.scrollLeft >= maxLeft - 8,
        index: index,
      };
    }

    function wrapBy(delta) {
      if (zoomLocked()) return false;
      var now = Date.now();
      if (now < lockUntil) return;
      var ends = atEnds();
      if (delta > 0 && ends.end) {
        lockUntil = now + 420;
        goToFn(0);
        return true;
      }
      if (delta < 0 && ends.start) {
        lockUntil = now + 420;
        goToFn(ends.index - 1);
        return true;
      }
      return false;
    }

    scroller.addEventListener(
      "wheel",
      function (e) {
        var dx = e.deltaX;
        var dy = e.deltaY;
        var delta = Math.abs(dx) >= Math.abs(dy) ? dx : dy;
        if (Math.abs(delta) < 6) return;
        if (wrapBy(delta)) e.preventDefault();
      },
      { passive: false }
    );

    scroller.addEventListener(
      "touchstart",
      function (e) {
        if (!e.touches[0]) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        startLeft = scroller.scrollLeft;
      },
      { passive: true }
    );

    scroller.addEventListener(
      "touchend",
      function (e) {
        var t = e.changedTouches[0];
        if (!t) return;
        var dx = startX - t.clientX;
        var dy = Math.abs(startY - t.clientY);
        if (Math.abs(dx) < 36 || dy > Math.abs(dx) + 12) return;
        var moved = Math.abs(scroller.scrollLeft - startLeft);
        if (moved > 12) return;
        wrapBy(dx);
      },
      { passive: true }
    );
  }

  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  function distance(a, b) {
    var dx = a.clientX - b.clientX;
    var dy = a.clientY - b.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function midpoint(a, b) {
    return {
      x: (a.clientX + b.clientX) / 2,
      y: (a.clientY + b.clientY) / 2,
    };
  }

  function wrapSlides(content) {
    var kids = Array.prototype.slice.call(content.children);
    var needsWrap = kids.some(function (el) {
      return (
        el.nodeType === 1 &&
        el.tagName !== "TEMPLATE" &&
        !el.classList.contains("zt-lightbox-slide")
      );
    });
    if (!needsWrap) {
      content.dataset.ztWrapped = "1";
      return;
    }
    kids.forEach(function (el) {
      if (el.nodeType !== 1 || el.tagName === "TEMPLATE") return;
      if (el.classList.contains("zt-lightbox-slide")) return;
      var slide = document.createElement("div");
      slide.className = "zt-lightbox-slide";
      if (el.classList.contains("active")) slide.classList.add("active");
      if (el.hasAttribute("data-media-id")) {
        slide.setAttribute("data-media-id", el.getAttribute("data-media-id"));
      }
      // Move Dawn's active class onto the slide shell.
      el.classList.remove("active");
      content.insertBefore(slide, el);
      slide.appendChild(el);

      var img = el.tagName === "IMG" ? el : el.querySelector("img");
      if (img) {
        img.classList.add("zt-lightbox-img");
        // Request a sharp source so pinch-zoom stays crisp.
        img.setAttribute("sizes", "200vw");
        img.draggable = false;
      }
    });
    content.dataset.ztWrapped = "1";
  }

  function bindModal(modal) {
    if (modal.dataset.ztModalBound === "1") return;
    modal.dataset.ztModalBound = "1";

    var content = modal.querySelector(".product-media-modal__content");
    if (!content) return;

    var countEl = ensureCount(modal, 2, "zt-modal-count");
    var scale = 1;
    var tx = 0;
    var ty = 0;
    var activeImg = null;
    var pinchStartDist = 0;
    var pinchStartScale = 1;
    var panStartX = 0;
    var panStartY = 0;
    var panOriginTx = 0;
    var panOriginTy = 0;
    var lastTapAt = 0;
    var lastTapX = 0;
    var lastTapY = 0;
    var gesturing = false;

    function slideItems() {
      return Array.prototype.filter.call(content.children, function (el) {
        return el.classList && el.classList.contains("zt-lightbox-slide");
      });
    }

    function currentSlide() {
      var items = slideItems();
      if (!items.length) return null;
      return items[activeIndexFromScroll(content, items)] || items[0];
    }

    function imgIn(slide) {
      if (!slide) return null;
      return slide.querySelector(".zt-lightbox-img") || slide.querySelector("img");
    }

    function resolveImg() {
      wrapSlides(content);
      var slide = currentSlide();
      var next = imgIn(slide);
      if (!next) {
        next =
          content.querySelector("img.active") ||
          content.querySelector(".zt-lightbox-img") ||
          content.querySelector("img");
      }
      if (next !== activeImg) {
        if (activeImg && activeImg.style) activeImg.style.transform = "";
        activeImg = next;
        scale = 1;
        tx = 0;
        ty = 0;
        content.classList.remove("is-zoomed");
        modal.classList.remove("is-zoomed");
        if (activeImg) {
          activeImg.classList.add("zt-lightbox-img");
          activeImg.draggable = false;
          activeImg.setAttribute("sizes", "200vw");
        }
      }
      return activeImg;
    }

    function applyTransform() {
      if (!activeImg) return;
      activeImg.style.transform =
        "translate3d(" + tx + "px," + ty + "px,0) scale(" + scale + ")";
      var zoomed = scale > 1.01;
      content.classList.toggle("is-zoomed", zoomed);
      modal.classList.toggle("is-zoomed", zoomed);
      if (zoomed) {
        content.style.overflowX = "hidden";
      } else {
        content.style.overflowX = "";
        tx = 0;
        ty = 0;
        activeImg.style.transform = "translate3d(0,0,0) scale(1)";
      }
    }

    function resetZoom() {
      scale = 1;
      tx = 0;
      ty = 0;
      if (activeImg) {
        activeImg.style.transform = "";
      }
      content.classList.remove("is-zoomed");
      modal.classList.remove("is-zoomed");
      content.style.overflowX = "";
    }

    function setActiveFromScroll() {
      resolveImg();
    }

    function paint() {
      var items = slideItems();
      var total = items.length;
      if (total < 2) {
        countEl.hidden = true;
        return;
      }
      countEl.hidden = false;
      countEl.textContent = activeIndexFromScroll(content, items) + 1 + " / " + total;
    }

    function goToModal(index) {
      wrapSlides(content);
      var kids = slideItems();
      if (!kids.length) return;
      var next = ((index % kids.length) + kids.length) % kids.length;
      var target = kids[next];
      if (!target) return;
      if (typeof content.scrollTo === "function") {
        content.scrollTo({ left: target.offsetLeft, behavior: "smooth" });
      } else {
        content.scrollLeft = target.offsetLeft;
      }
      window.requestAnimationFrame(function () {
        setActiveFromScroll();
        paint();
      });
    }

    function scrollActiveIntoView() {
      wrapSlides(content);
      var items = slideItems();
      var active =
        content.querySelector(".zt-lightbox-slide.active") ||
        content.querySelector("[data-media-id].active") ||
        items[0];
      // Prefer the media Dawn marked active (may still be on img before wrap sync).
      var dawnActive = content.querySelector("img.active, [data-media-id].active");
      if (dawnActive) {
        var shell = dawnActive.closest(".zt-lightbox-slide");
        if (shell) active = shell;
      }
      if (!active) return;
      items.forEach(function (s) {
        s.classList.toggle("active", s === active);
      });
      content.scrollLeft = active.offsetLeft;
      setActiveFromScroll();
      paint();
    }

    function clampPan() {
      if (!activeImg || scale <= 1) {
        tx = 0;
        ty = 0;
        return;
      }
      var layoutW = activeImg.offsetWidth * scale;
      var layoutH = activeImg.offsetHeight * scale;
      var maxX = Math.max(0, (layoutW - window.innerWidth) / 2 + 16);
      var maxY = Math.max(0, (layoutH - window.innerHeight) / 2 + 16);
      tx = clamp(tx, -maxX, maxX);
      ty = clamp(ty, -maxY, maxY);
    }

    function zoomTo(nextScale, cx, cy) {
      if (!activeImg) return;
      var prev = scale || 1;
      scale = clamp(nextScale, MIN_SCALE, MAX_SCALE);
      if (scale <= 1.01) {
        resetZoom();
        return;
      }
      var ratio = scale / prev;
      tx = cx - window.innerWidth / 2 - (cx - window.innerWidth / 2 - tx) * ratio;
      ty = cy - window.innerHeight / 2 - (cy - window.innerHeight / 2 - ty) * ratio;
      clampPan();
      applyTransform();
    }

    content.addEventListener(
      "scroll",
      function () {
        if (scale > 1.01) return;
        setActiveFromScroll();
        paint();
      },
      { passive: true }
    );

    function modalOpen() {
      return modal.hasAttribute("open");
    }

    function applyPinchScale(nextScale, cx, cy) {
      if (!resolveImg()) return;
      var prevScale = scale;
      scale = clamp(nextScale, MIN_SCALE, MAX_SCALE);
      if (scale <= 1.01) {
        resetZoom();
        return;
      }
      if (prevScale !== scale && cx != null) {
        var ratio = scale / (prevScale || 1);
        tx = cx - window.innerWidth / 2 - (cx - window.innerWidth / 2 - tx) * ratio;
        ty = cy - window.innerHeight / 2 - (cy - window.innerHeight / 2 - ty) * ratio;
      }
      clampPan();
      applyTransform();
    }

    // iOS Safari: gesture* is the only reliable pinch. preventDefault stops page zoom.
    function onGestureStart(e) {
      if (!modalOpen()) return;
      e.preventDefault();
      resolveImg();
      gesturing = true;
      pinchStartScale = scale || 1;
    }

    function onGestureChange(e) {
      if (!modalOpen()) return;
      e.preventDefault();
      var cx = e.clientX;
      var cy = e.clientY;
      applyPinchScale(pinchStartScale * (e.scale || 1), cx, cy);
    }

    function onGestureEnd(e) {
      if (!modalOpen()) return;
      e.preventDefault();
      gesturing = false;
      pinchStartDist = 0;
      if (scale <= 1.01) resetZoom();
    }

    document.addEventListener("gesturestart", onGestureStart, { capture: true, passive: false });
    document.addEventListener("gesturechange", onGestureChange, { capture: true, passive: false });
    document.addEventListener("gestureend", onGestureEnd, { capture: true, passive: false });

    var safariPinch = "ongesturestart" in window;

    modal.addEventListener(
      "touchstart",
      function (e) {
        if (!modalOpen()) return;
        resolveImg();
        if (!activeImg) return;

        if (e.touches.length === 2) {
          gesturing = true;
          pinchStartDist = distance(e.touches[0], e.touches[1]);
          pinchStartScale = scale || 1;
          // Do not preventDefault here on iOS — that kills gesturechange.
          if (!safariPinch) e.preventDefault();
          return;
        }

        if (e.touches.length === 1 && scale > 1.01) {
          gesturing = true;
          panStartX = e.touches[0].clientX;
          panStartY = e.touches[0].clientY;
          panOriginTx = tx;
          panOriginTy = ty;
        }
      },
      { passive: false, capture: true }
    );

    modal.addEventListener(
      "touchmove",
      function (e) {
        if (!modalOpen() || !activeImg) return;

        if (e.touches.length === 2 && pinchStartDist) {
          if (safariPinch) return;
          var dist = distance(e.touches[0], e.touches[1]);
          var mid = midpoint(e.touches[0], e.touches[1]);
          applyPinchScale((pinchStartScale * dist) / pinchStartDist, mid.x, mid.y);
          e.preventDefault();
          return;
        }

        if (e.touches.length === 1 && scale > 1.01 && gesturing) {
          tx = panOriginTx + (e.touches[0].clientX - panStartX);
          ty = panOriginTy + (e.touches[0].clientY - panStartY);
          clampPan();
          applyTransform();
          e.preventDefault();
        }
      },
      { passive: false, capture: true }
    );

    modal.addEventListener(
      "touchend",
      function (e) {
        if (!modalOpen()) return;
        if (e.touches.length < 2) pinchStartDist = 0;

        if (e.touches.length === 0) {
          if (!gesturing || scale <= 1.01) {
            var t = e.changedTouches[0];
            if (t) {
              var now = Date.now();
              var dt = now - lastTapAt;
              var dx = Math.abs(t.clientX - lastTapX);
              var dy = Math.abs(t.clientY - lastTapY);
              if (dt < DOUBLE_TAP_MS && dx < 24 && dy < 24) {
                resolveImg();
                if (scale > 1.01) {
                  resetZoom();
                } else {
                  scale = 1;
                  tx = 0;
                  ty = 0;
                  zoomTo(2.4, t.clientX, t.clientY);
                }
                lastTapAt = 0;
                e.preventDefault();
              } else {
                lastTapAt = now;
                lastTapX = t.clientX;
                lastTapY = t.clientY;
              }
            }
          }
          gesturing = false;
          if (scale <= 1.01) resetZoom();
        }
      },
      { passive: false, capture: true }
    );

    // Desktop: click toggles mild zoom; wheel zooms.
    content.addEventListener("dblclick", function (e) {
      if (window.matchMedia("(max-width: 749px)").matches) return;
      setActiveFromScroll();
      if (!activeImg) return;
      if (scale > 1.01) {
        resetZoom();
      } else {
        zoomTo(2.2, e.clientX, e.clientY);
      }
    });

    wrapSlides(content);

    var observer = new MutationObserver(function () {
      if (modal.hasAttribute("open")) {
        resetZoom();
        window.requestAnimationFrame(scrollActiveIntoView);
        window.setTimeout(scrollActiveIntoView, 50);
      } else {
        resetZoom();
      }
    });
    observer.observe(modal, { attributes: true, attributeFilter: ["open"] });

    if (modal.hasAttribute("open")) {
      scrollActiveIntoView();
    }

    bindWrapGestures(content, slideItems, function (index) {
      if (scale > 1.01) return;
      goToModal(index);
    });
  }

  function jumpGalleryToMedia(gallery, mediaId) {
    if (!gallery || !mediaId) return;
    var id = String(mediaId);
    var item =
      gallery.querySelector('[data-media-id="' + id + '"]') ||
      gallery.querySelector('[data-media-id$="-' + id.replace(/^.*-/, "") + '"]');
    if (!item) return;
    var list = gallery.querySelector(".product__media-list");
    var items = list ? list.querySelectorAll(".product__media-item") : [];
    var idx = Array.prototype.indexOf.call(items, item);
    if (typeof gallery._ztGoTo === "function" && idx >= 0) {
      gallery._ztGoTo(idx);
      return;
    }
    if (list && item) {
      var left = item.offsetLeft;
      if (typeof list.scrollTo === "function") list.scrollTo({ left: left, behavior: "smooth" });
      else list.scrollLeft = left;
    }
  }

  function patchSetActiveMedia() {
    var Ctor = customElements.get("media-gallery");
    if (!Ctor || !Ctor.prototype || Ctor.prototype._ztColorJump) return;
    var orig = Ctor.prototype.setActiveMedia;
    Ctor.prototype.setActiveMedia = function (mediaId, prepend) {
      if (typeof orig === "function") orig.call(this, mediaId, prepend);
      jumpGalleryToMedia(this, mediaId);
    };
    Ctor.prototype._ztColorJump = true;
  }

  function boot() {
    patchSetActiveMedia();
    document.querySelectorAll("media-gallery").forEach(bindGallery);
    document.querySelectorAll("product-modal").forEach(bindModal);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();
